<template>
  <mail-templates-editor v-model="mail_template" v-if="mail_template"></mail-templates-editor>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';

export default {
  data: function () {
    return {
      mail_template: null
    };
  },
  methods: {},
  async mounted() {
    let breadcrumbs = [
      { to: { name: 'settings_index' }, text: this.$t('settings') },
      {
        to: { name: 'mail_templates' },
        text: this.$t('routes_mail_templates')
      },
      { to: { name: 'mail_template_create' }, text: this.$t('create') }
    ];

    this.setBreadcrumbs(breadcrumbs);

    let { data: template } = await Api.find('mail_templates', 'default');
    this.mail_template = _.omit(template, 'id');

    console.log(template);
  }
};
</script>

<style scoped></style>
